import { render, staticRenderFns } from "./AnnouncementCreate.vue?vue&type=template&id=7e634f09&scoped=true&"
import script from "./AnnouncementCreate.vue?vue&type=script&lang=js&"
export * from "./AnnouncementCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e634f09",
  null
  
)

export default component.exports